module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/august/mainvisual-present_17273927dccf6a81bbb1f55afdcad13e.png";